import React, { useEffect, useState } from 'react'
import axios from 'axios';
import baseUrl from '../../utils/config';
import Cookies from "js-cookie";
import ViewportMeta from '../../utils/ViewportMeta';
import { useNavigate } from 'react-router-dom';
import { DotLoader } from 'react-spinners';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate();


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // don't use newRequest here because it will set token in header and we don't want that here because we are using cookie
      // instead use axios here and set token in cookie using js-cookie library
      const response = await axios.post(baseUrl + "/login",
        {
          loginname: email,
          loginpass: password
        }
      );

      // localStorage.setItem("currentUser", JSON.stringify(response?.data?.user));
      setIsLoading(false);
      // set token in cookie
      Cookies.set("accessToken", response?.data?.token);
      navigate('/admin/dashboard')
      sessionStorage.setItem('accessToken', response?.data?.token)
    } catch (error) {
      setIsLoading(false);
      setError(error?.response?.data?.message || error?.message || "Something went wrong!");

    }
  };
  useEffect(() => {
    setError(null);
  }, [email, password]);
  return (
    <>
      {isLoading && <div className='loading-spinner-background'
        style={{
          zIndex: 9999, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.5)',
          display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed'
        }}
      >
        <DotLoader
          size={45}
          color={"#FF693A"}
          // height={4}
          loading={isLoading}
        />
      </div>
      }
      <ViewportMeta />

      <div className="bg-white dark:bg-gray-900">
        <div className="flex justify-center h-screen">
          <div className="hidden bg-cover lg:block lg:w-2/3" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1616763355603-9755a640a287?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80)' }}>
            <div className="flex items-center h-full px-20 bg-gray-900 bg-opacity-40">
              <div>
                <h2 className="text-7xl font-bold text-white">Admin Panel</h2>
                {/* <p className="max-w-xl mt-3 text-gray-300">Saudi EXIM Bank</p> */}
              </div>
            </div>
          </div>
          <div className="flex items-center w-full max-w-md px-6 mx-auto lg:w-2/6">
            <div className="flex-1">
              <div className="text-center">
                <h2 className="text-4xl font-bold text-center text-gray-700 dark:text-white">Admin Panel</h2>
                <p className="mt-3 text-gray-500 dark:text-gray-300 font-extrabold">Sign in to access your Admin Panel</p>
              </div>
              <div className="mt-8">
                <form onSubmit={handleSubmit}>
                  <div>
                    <label htmlFor="email" className="block mb-2 text-sm text-gray-600 dark:text-gray-200">Email Address</label>
                    <input required type="text" name="email" id="email" placeholder="example@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}

                      className="block w-full px-4 py-2 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-md dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40" />
                  </div>
                  <div className="mt-6">
                    <div className="flex justify-between mb-2">
                      <label htmlFor="password" className="text-sm text-gray-600 dark:text-gray-200">Password</label>
                      <a href="#" className="text-sm text-gray-400 focus:text-blue-500 hover:text-blue-500 hover:underline" onClick={() => navigate('/admin-forgot')}>Forgot password?</a>
                    </div>
                    <input
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      type="password" name="password" id="password" placeholder="Your Password" className="block w-full px-4 py-2 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-md dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40" />
                  </div>
                  <div className="mt-6">
                    <button
                      type='submit'
                      className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-blue-500 rounded-md hover:bg-blue-400 focus:outline-none focus:bg-blue-400 focus:ring focus:ring-blue-300 focus:ring-opacity-50">
                      Sign in
                    </button>
                    {error && (
                      <div
                        className="mt-4 text-sm text-center text-red-500"
                      >
                        <div
                          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                        >
                          {error}
                        </div>
                      </div>
                    )}
                  </div>
                </form>
                <p className="mt-6 text-sm text-center text-gray-400" onClick={() => navigate('/admin-signup')}>Don't have an account yet? <a href="#" className="text-blue-500 focus:outline-none focus:underline hover:underline">Sign up</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Login